import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "service-status-item-page",
  class: "serviceStatusItem"
}
const _hoisted_2 = ["href"]

import { useRouter } from 'vue-router';
import {
  Icon,
  InfoCard,
  ServiceStatusItem,
  RouteServiceStatus,
} from '@components';
import { computed } from 'vue';
import formatInTimeZone from 'date-fns-tz/formatInTimeZone';
import LiveBanner from './Components/LiveBanner.vue';
import { stayUpdatedUrl, timetableResultsUrl, timezone } from '../envVariables';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceStatusItemPage',
  setup(__props) {

const router = useRouter();
const routeCode = computed(() => router.currentRoute.value?.params?.routeCode?.toString());

const timetableRoute = (routeServed: RouteServiceStatus) => {
  if (!routeServed || !routeServed.ports[0] || !routeServed.ports[1]) return;
  window.location.href = `${timetableResultsUrl}/${router.resolve({
    name: 'timetableResult',
    params: {
      from: routeServed.ports[0].name,
      to: routeServed.ports[1].name,
      departureDate: formatInTimeZone(new Date(), timezone, 'yyyy-MM-dd'),
    },
  }).href}`;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ServiceStatusItem), {
      "is-mobile-app-view": false,
      "route-code": routeCode.value,
      "route-to-timetable": timetableRoute
    }, {
      infoCard: _withCtx(() => [
        _createElementVNode("a", {
          href: _unref(stayUpdatedUrl),
          "aria-label": "receive updates",
          class: "infoCardLink"
        }, [
          _createVNode(_unref(InfoCard), {
            "icon-name": "eye",
            text: _ctx.$t('Receive live updates text'),
            "background-color": "#DAEDED"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Icon), { "icon-name": "link" })
            ]),
            _: 1
          }, 8, ["text"])
        ], 8, _hoisted_2)
      ]),
      liveUpdatesInfoCard: _withCtx(() => [
        _createVNode(LiveBanner)
      ]),
      _: 1
    }, 8, ["route-code"])
  ]))
}
}

})